import { css } from '@emotion/css';
import Skeleton from 'atoms/Skeleton';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingEnd, loadingStart } from 'store/globalSlice';
import { RootState } from 'store/store';
import { setParticipantDetails } from 'store/userSlice';
import { colors } from 'styles/colors';
import { ParticipantAPI } from 'utils/ParticipantAPI';

const FoodDiaryPage = () => {
    const dispatch = useDispatch();
    const token = useSelector((state: RootState) => state.global.authToken);
    const isLoading = useSelector((state: RootState) => state.global.isLoading);
    const participantDetails = useSelector((state: RootState) => state.user.participantDetails);

    const getDetails = useCallback(async () => {
        try {
            dispatch(loadingStart());
            const participantDetailsResponse = await ParticipantAPI.getParticipantDetails(token ?? '');
            dispatch(setParticipantDetails(participantDetailsResponse));
        } catch (e) {
            console.error(e);
        } finally {
            dispatch(loadingEnd());
        }
    }, [dispatch, token]);
    
    useEffect(() => {
        getDetails();
    }, [getDetails]);
        
    return (
        <div className={styles.page}>
            <div className={styles.content}>
                <div className={styles.textContainer}>
                    <Skeleton loading={isLoading}>
                        <div className={styles.title}>Kostdagbog</div>
                    </Skeleton>
                    <Skeleton loading={isLoading}>
                        <div className={styles.underTitleText}>
                            Her kan du registrere alt hvad du har spist og drukket. Husk at du kun skal registrere for de dage der specificeres på din tidslinje.
                        </div>
                    </Skeleton>
                </div>

                <div className={styles.cardsConteiner}>
                    <Skeleton style={{ display: 'flex', flex: 1, maxWidth: '100%' }} variant='rounded' loading={isLoading}>
                        {!participantDetails ? <div className={styles.iframe} /> :
                            <iframe
                                className={styles.iframe}
                                id="inlineFrame"
                                title="Inline Frame"
                                src={`${process.env.REACT_APP_MYFOOD24_URL}/${participantDetails!.participantId}`}
                            />
                        }
                    </Skeleton>
                </div>
            </div>
        </div>
    );
};

const styles = {
    page: css({
        display: 'flex',
        height: '100vh',
        paddingLeft: '2rem',
        paddingRight: '2rem',
    }),
    content: css({
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        marginTop: '4.5rem',
        marginBottom: '4.5rem',
        paddingTop: '2.5rem',
    }),
    textContainer: css({
        justifyContent: 'flex-start',
        width: '100%',
        marginBottom: '2rem',
    }),
    title: css({
        color: colors.primaryText,
        fontFamily: 'Figtree',
        fontSize: '35px',
        fontWeight: 'bold',
        lineHeight: 'normal',
        paddingBottom: '1rem',
    }),
    underTitleText: css({
        color: colors.primaryText,
        fontFamily: 'Figtree',
        fontSize: '22px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '150%',
        letterSpacing: '0.0275rem',
        maxWidth: '80rem',
    }),
    cardsConteiner: css({
        flex: 1,
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center', // center the Grid block
    }),
    iframe: css({
        width: '100%',
        height: '100%',
    }),
};

export default FoodDiaryPage;